import { nanoid } from 'nanoid'

import { SpendVariance } from '@webapp/components/SpendVariance'
import { CostSummary } from '@webapp/core/components/CostSummary'
import { Price } from '@webapp/core/components/Price'
import { BudgetCategoryCardDetailsBreakdownRowIconStyled } from '../BudgetCategoryCardDetailsBreakdownRowIcon'
export interface IBudgetCategoryCardDetailsBreakdownRowwProps {
  name: string
  amount: string | number
  addition?: boolean
  negation?: boolean
  highlight?: boolean
  danger?: boolean
  iconColor?: string
  iconStriped?: boolean
  variancePercentage?: string | number
}

export const BudgetCategoryCardDetailsBreakdownRow = ({
  name,
  amount,
  iconColor,
  iconStriped = false,
  addition = false,
  negation = false,
  highlight = false,
  danger = false,
  variancePercentage,
}: IBudgetCategoryCardDetailsBreakdownRowwProps) => {
  const id = nanoid()

  return (
    <>
      {!highlight && (
        <CostSummary.Cost>
          <th id={id}>
            {iconColor && (
              <BudgetCategoryCardDetailsBreakdownRowIconStyled
                color={iconColor}
                striped={iconStriped}
              />
            )}
            {name}
          </th>
          <td aria-labelledby={id}>
            {addition && `+ `}
            {negation && `- `}
            <Price price={amount} />
          </td>
        </CostSummary.Cost>
      )}

      {highlight && (
        <CostSummary.Total>
          <th id={id}>{name}</th>
          <td aria-labelledby={id}>
            {variancePercentage ? (
              <SpendVariance
                variance={amount}
                variancePercentage={variancePercentage}
                isOverBudget={danger}
              />
            ) : (
              <Price price={amount} color={danger ? 'danger' : 'textPrimary'} />
            )}
          </td>
        </CostSummary.Total>
      )}
    </>
  )
}

BudgetCategoryCardDetailsBreakdownRow.displayName =
  'BudgetCategoryCardDetailsBreakdownRow'
